import React from 'react'

const ComparisonReport = () => {
  return (
    <div>
      
    </div>
  )
}

export default ComparisonReport
